<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  message: { type: String, default: '' },
  progress: { type: Number, default: 0 },
  status: { type: String, default: 'idle' },
});

const emit = defineEmits(['confirm']);
const { t } = useI18n();
const progressWidth = computed(() => {
  if (props.progress >= 100) return 'w-full';
  if (props.progress >= 70) return 'w-[70%]';
  if (props.progress >= 40) return 'w-2/5';
  return props.progress > 0 ? 'w-[1%]' : 'w-0';
});
const messageClass = computed(() =>
  ['invalid', 'not_configured', 'unavailable'].includes(props.status)
    ? 'text-lais-warning-text'
    : 'text-lais-text-muted'
);
</script>

<template>
  <footer
    class="sticky bottom-0 z-20 border-t border-lais-border bg-white shadow-lg"
  >
    <div
      v-if="progress > 0"
      class="h-1 w-full overflow-hidden bg-lais-bg-soft"
      role="progressbar"
      :aria-valuenow="progress"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-label="t('SALES.CREATE.ONUS.PROGRESS')"
    >
      <div
        class="h-full bg-lais-primary transition-[width] duration-300"
        :class="progressWidth"
      />
    </div>
    <div
      class="mx-auto flex min-h-[82px] w-full max-w-[1100px] flex-col justify-center gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-10"
    >
      <p
        class="flex min-h-6 items-center gap-2 text-sm"
        :class="messageClass"
        role="status"
      >
        <span
          v-if="status === 'processing'"
          class="i-lucide-loader-circle size-4 animate-spin text-lais-primary"
          aria-hidden="true"
        />
        {{ message }}
      </p>
      <LaisPrimaryButton
        size="lg"
        icon="i-lucide-arrow-right"
        :disabled="disabled"
        :is-loading="loading"
        @click="emit('confirm')"
      >
        {{ t('SALES.CREATE.CONTINUE_REGISTRATION') }}
      </LaisPrimaryButton>
    </div>
  </footer>
</template>
